function toggleProductGrid(lines) {
  const productGrid = document.querySelector('.mmc-loop.product-grid');
    
  productGrid.classList.remove('collection__page-products-3');
  productGrid.classList.remove('collection__page-products');
  productGrid.classList.remove('collection__page-products-2');
  productGrid.classList.remove('collection__page-products-1');
    
  if (lines === 2) {
    productGrid.classList.add('collection__page-products-2');
  } else if (lines === 1) {
    productGrid.classList.add('collection__page-products-1');
  }else if (lines === 3) {
    productGrid.classList.add('collection__page-products-3');
  }
  const gridButtons = document.querySelectorAll('.st-grid-changer button , .st-desktop-product-grid-changer button');
  const currentColumns = parseInt(lines);

  gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); 
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('scroll', function () {
    const bar = document.querySelector('.st-mobile-collection-top');
    if (window.scrollY > 300) {
      bar.classList.add('sticky-filter-bar');
    } else {
      bar.classList.remove('sticky-filter-bar');
    }
  });
  const gridButtons = document.querySelectorAll('.st-grid-changer button , .st-desktop-product-grid-changer button');
  if (window.innerWidth <= 768) { 
    gridButtons.forEach(button => {
      const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
      if (buttonColumns === 2) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  let backToTop = document.querySelector(".st-collection-scroll-top");
  if (backToTop) {
    backToTop.addEventListener("click", () => {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }

  window.addEventListener("scroll", () => {
    if (backToTop && window.scrollY > 500) {
      backToTop.style.display = "flex";
    } else if (backToTop && window.scrollY <= 500) {
      backToTop.style.display = "none";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const counterDiv = document.querySelector(".st-counter");
  if (!counterDiv) {
    console.warn("⚠️ .st-counter not found");
    return;
  }
  const viewCountEl = counterDiv.querySelector(".view-count");

  function updateViewCount() {
    const products = document.querySelectorAll(".product-grid .product-card"); 
    if (products.length === 0) return;
    const currentPage = getCurrentPage();
    // const perPage = products.length;
    const pageOffset = (currentPage - 1) * 32;
    let viewedCount = 0;
    const scrollBottom = window.scrollY + window.innerHeight;
    products.forEach((product, i) => {
      const rect = product.getBoundingClientRect();
      const absoluteTop = rect.top + window.scrollY;

      if (absoluteTop < scrollBottom) {
        viewedCount = i + 1;
      }
    });
    viewedCount = viewedCount + pageOffset;
    viewCountEl.textContent = viewedCount;
    counterDiv.style.display = viewedCount >= 4 ? "flex" : "none";
  }
  updateViewCount();
  window.addEventListener("scroll", updateViewCount);
  window.addEventListener("resize", updateViewCount);
  const footer = document.querySelector("footer.footer");
  if (footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            counterDiv.style.display = "none";
          } else {
            updateViewCount();
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(footer);
  }
  function getCurrentPage() {
    // const url = new URL(window.location.href);
    // return parseInt(url.searchParams.get("page") || "1", 10);
    const current = document.querySelector(
      ".pagination__list .pagination__item--current"
    );
    if (!current) return 1; // fallback if not found

    // aria-label="Page 2" → extract the number
    const label = current.getAttribute("aria-label") || "";
    const match = label.match(/\d+/); // find digits
    return match ? parseInt(match[0], 10) : 1;
  }
  window.addEventListener("st.collection.paginated", updateViewCount);
});

document.addEventListener("DOMContentLoaded",function(){
  const baseUrl = window.Shopify?.routes?.root || ''; // adjust if needed
const DEFAULT_IMAGE = '//cdn.shopify.com/s/files/default-image.png'; // fallback

document.querySelectorAll('[data-selector="product-card"]').forEach(productCard => {
  const productHandle = productCard.getAttribute('data-product-variant-handle');
  if (!productHandle) return;

  // ---- Get size swatches from PDP ----
  fetch(`${baseUrl}products/${productHandle}`)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sizeEl = doc.querySelector('.product__size__variants');
      // if (!sizeEl) return;
      const colorEl = doc.querySelector('.product__color__variants');
      const capacityEl = doc.querySelector('.variant-picker-wrapper label');
      // if (!colorEl) return;
      const container = productCard.querySelector('.st-swatches');
      const capacitySwatches = productCard.querySelector('.st-capacity-swatches');
      const capacityDropdown = productCard.querySelector('.st-capacity-dropdown');
      // if (!container) return;
      const colorContainer = productCard.querySelector('.st-color-swatches');
      if(sizeEl && container){
        container.innerHTML = sizeEl.innerHTML;
        renderSizeDropdown(productCard,sizeEl);
      }
      else{
        container.innerHTML = '';
        productCard.querySelector('.st-size-dropdown').innerHTML = '';
      }
      if(colorEl && colorContainer){
        colorContainer.innerHTML = colorEl.innerHTML;
      }

      if(capacityEl && !sizeEl && capacitySwatches && capacityDropdown){
        const value = capacityEl.childNodes[0].nodeValue.trim();
        capacityDropdown.innerText = value;
        capacitySwatches.innerText = value;
      } else if(capacityEl && sizeEl && capacitySwatches && capacityDropdown){
        capacitySwatches.classList.add('st-size-swatches-available');
        capacityDropdown.classList.add('st-size-swatches-available');
      }
      selectChangeListener(productCard,productHandle);     
      bindSwatches(productCard, container, productHandle, true);
      bindSwatches(productCard, colorContainer, productHandle, false);
      updateSoldOutProducts(productCard);
    })
    .catch(err => console.error('Error fetching size swatches:', err));
});
function updateSoldOutProducts(productCard){
  const select = productCard.querySelector('#variant-size-select');
  if (select) {
    const currentOption = select.options[select.selectedIndex];
    const enabledOptions = [...select.options].filter(opt => !opt.disabled);
    if (currentOption && currentOption.disabled && enabledOptions.length > 0) {
      select.value = enabledOptions[0].value;
      select.dispatchEvent(new Event('change'));
    }
  }
  const colorVariants = productCard.querySelector('.color-variants-wrapper');
  if(colorVariants){
    const currentChecked = colorVariants.querySelector('label.checked');
    if (currentChecked && currentChecked.classList.contains('disabled-variant')) {
      const firstValid = colorVariants.querySelector('label:not(.disabled-variant)');
      if (firstValid) {
        firstValid.click();
      }
    }
  }
  const sizeVariants = productCard.querySelector('.st-swatches');
  if(sizeVariants && sizeVariants.children.length !== 0){
    const currentChecked = sizeVariants.querySelector('label.checked');
    if (currentChecked && currentChecked.classList.contains('disabled-variant')) {
      const firstValid = sizeVariants.querySelector('label:not(.disabled-variant)');
      if (firstValid) {
        firstValid.click();
      }
    }
  }
}
function renderSizeDropdown(productCard,sizeElement){
  if (sizeElement) {
    const sizeOptions = [];
    const scriptBlocks = [];

    sizeElement.querySelectorAll('input.product-variant-title').forEach(input => {
      const label = sizeElement.querySelector(`label[for="${input.id}"]`);
      const title = input.dataset.variantTitle || label?.textContent?.trim();
      const productId = input.dataset.productId;
      // const disabled = input.dataset.available === 'false' ? true : false;
      const disabled = input.dataset.available ? false : true;

      sizeOptions.push({
        title,
        productId,
        disabled,
        selected: input.checked,
      });
      const script = sizeElement.querySelector(`script[data-variant-id="${productId}"]`);
      if (script) scriptBlocks.push(script.outerHTML);
    });
    const hasSingleOption = sizeOptions.length === 1;
    const selectHTML = `
      <div class="product__size__select${hasSingleOption ? ' st-single-option' : ''}">
      ${
        hasSingleOption
        ? `
          <div class="variant-select tw-w-full tw-border tw-rounded-md tw-p-2 tw-bg-gray-100">
            ${sizeOptions[0].title}
            ${sizeOptions[0].disabled ? ' - Sold out' : ''}
          </div>
        `
        : `
        <select id="variant-size-select" class="variant-select select__select tw-w-full tw-border tw-rounded-md tw-p-2">
          ${sizeOptions
            .map(
              opt => `
              <option value="${opt.productId}"
              ${opt.disabled ? 'disabled' : ''}
              ${opt.selected ? 'selected' : ''}>
              ${opt.title} ${opt.disabled ? ' - Sold out' : ''}
              </option>`
            )
            .join('')
          }
        </select>
        `
      }
      ${scriptBlocks.join('\n')}
    </div>
    `;
    productCard.querySelector('.st-size-dropdown').innerHTML = selectHTML;
  }
}

function selectChangeListener(productCard,productHandle) {
  const _this = this;
  const sizeElement = productCard.querySelector('.product__size__select');
  productCard.querySelectorAll('.variant-select').forEach((select) => {
    select.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const variantId = selectedOption.value;
      const script = sizeElement?.querySelector(`script[data-variant-id="${variantId}"]`);
      if (!script) return;
      const variantData = JSON.parse(script.textContent);
      updateProductCardUI(productCard, variantData);

      if(variantData.available){
        productCard.querySelector('product-form').outerHTML = createAddToCart(variantData.id, variantData.variants?.[0]?.id);
      }
      else{
        productCard.querySelector('product-form').outerHTML = createSoldOut(variantData.id);
      }

      updateProductForm(productCard, {
        id: variantData.variants?.find(v => v.inventory_quantity > 0)?.id || variantData.variants?.[0]?.id,
        productId: variantData.id,
        available: variantData.available
      });
      updateCheckedSizeSwatch(productCard,variantId);
      getColorSwatches(productCard,productHandle);
    });
  });
}

function updateCheckedSizeSwatch(productCard,productId){
  const sizeContainer = productCard.querySelector('.st-swatches');
  if (sizeContainer) {
    sizeContainer.querySelectorAll('.product-as-variants-label').forEach(label => {
      if (label.classList.contains('disabled-variant')) return;

      sizeContainer.querySelectorAll('.product-as-variants-label').forEach(l => l.classList.remove('checked'));

      const radio = sizeContainer.querySelector(`input[type="radio"][data-product-id="${productId}"]`);
      if (radio) {
        sizeContainer.querySelectorAll('.product-variant-title input').forEach(r => (r.checked = false));
        radio.checked = true;
        let radioId = radio.id;
        sizeContainer.querySelector(`label[for=${radioId}]`).classList.add('checked');
      }
    });
  }
}

// ---- Fetch & render color swatches ----
function getColorSwatches(productCard, productHandle) {
  fetch(`${baseUrl}products/${productHandle}`)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const colorEl = doc.querySelector('.product__color__variants');
      if (!colorEl) return;

      const container = productCard.querySelector('.st-color-swatches');
      if (!container) return;

      container.innerHTML = colorEl.innerHTML;

      bindSwatches(productCard, container, productHandle, false);
    })
    .catch(err => console.error('Error fetching color swatches:', err));
}

function getSizeSwatches(productCard, productHandle) {
  fetch(`${baseUrl}products/${productHandle}`)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sizeEl = doc.querySelector('.product__size__variants');
      // if (!sizeEl) return;
      const container = productCard.querySelector('.st-swatches');
      // if (!container) return;
      const colorContainer = productCard.querySelector('.st-color-swatches');
      if(sizeEl && container){
        container.innerHTML = sizeEl.innerHTML;
        renderSizeDropdown(productCard,sizeEl);
      }
      else{
        container.innerHTML = '';
        productCard.querySelector('.st-size-dropdown').innerHTML = '';
      }
      selectChangeListener(productCard,productHandle);     
      bindSwatches(productCard, container, productHandle, true);
    })
    .catch(err => console.error('Error fetching color swatches:', err));
}

// ---- Common swatch binding for size/color ----
function bindSwatches(productCard, container, productHandle, isSize) {
  const labels = container.querySelectorAll(isSize ? '.product-as-variants-label' : '.product-as-variants-color-label'); 
  labels.forEach(label => {
    label.addEventListener('click', () => {
      if (label.classList.contains('disabled-variant')) return;

      labels.forEach(l => l.classList.remove('checked'));
      label.classList.add('checked');

      const radio = container.querySelector(`#${label.getAttribute('for')}`);
      if (!radio) return;
      if(isSize){
        const productId = radio.dataset.productId;
        const dropdownElement = productCard.querySelector('.product__size__select .variant-select');
        if(dropdownElement){
          dropdownElement.querySelector(`option[value="${productId}"]`).selected = true;
        }
      }
      const allRadios = container.querySelectorAll('input[type="radio"]');
      allRadios.forEach(r => (r.checked = false));
      radio.checked = true;
      const script = label.parentElement.querySelector(`script[data-variant-id="${radio.value}"]`);
      if (script) {
        const variantData = JSON.parse(script.textContent);
        updateProductCardUI(productCard, variantData);

        if(productCard.querySelector('product-form')){
          if(variantData.available){
            productCard.querySelector('product-form').outerHTML = createAddToCart(variantData.id, variantData.variants?.[0]?.id);
          }
          else{
            productCard.querySelector('product-form').outerHTML = createSoldOut(variantData.id);
          }
        }

        updateProductForm(productCard, {
          id: variantData.variants?.find(v => v.inventory_quantity > 0)?.id || variantData.variants?.[0]?.id,
          productId: variantData.id,
          available: variantData.available
        });
        if (label.classList.contains('product-as-variants-label')) {
          getColorSwatches(productCard, variantData.handle);
        }
        if(label.classList.contains('product-as-variants-color-label')){
          getSizeSwatches(productCard,variantData.handle);
        }
      }
    });
  });
}

function updateProductForm(container, newVariant) {
  const form = container.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  const variantInput = form.querySelector('input[name="id"]');
  if (variantInput) {
    variantInput.value = newVariant.id;
    variantInput.disabled = false; 
  }

  const productInput = form.querySelector('input[name="product-id"]');
  if (productInput) {
    productInput.value = newVariant.productId;
    productInput.disabled = false; 
  }
  const oldFormId = form.id;
  form.id = `product-form--undefined--${newVariant.productId}`;
  const submitButton = form.querySelector('button[type="submit"]');
  if (submitButton) {
    submitButton.id = `product-form--undefined--${newVariant.productId}-submit`;
    submitButton.setAttribute(
      'aria-labelledby',
      `product-form--undefined--${newVariant.productId}-submit title-undefined-${newVariant.productId}`
    );
    if (!newVariant.available) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
    } else {
      submitButton.disabled = false;
      submitButton.setAttribute('aria-disabled', 'false');
    }
  }
}


function createAddToCart(productId, variantId) {
  console.log("Add to cart function called for",productId);
  return `
    <product-form class="tw-w-full tw-flex tw-justify-end">
      <form method="post" action="/cart/add" 
        id="product-form--undefined--${productId}"
        accept-charset="UTF-8" 
        class="form st-flex" 
        enctype="multipart/form-data" 
        novalidate 
        data-type="add-to-cart-form">

        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="id" value="${variantId}">

        <button 
          id="product-form--undefined--${productId}-submit" 
          type="submit" 
          name="add" 
          class="quick-add__submit product-card--btn !tw-flex tw-bg-transparent tw-relative card--horizontal__quick-add" 
          aria-haspopup="dialog" 
          aria-labelledby="product-form--undefined--${productId}-submit title-undefined-${productId}" 
          aria-live="polite" 
          aria-disabled="false" 
          data-sold-out-message="true">

          <span class="add-cart--icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 23 24" fill="none">
              <path d="M8.57535 10.1143V4.94485C9.05154 0.71532 14.2896 1.65526 14.2896 4.94485V10.1143" stroke="#4A4A4A" stroke-width="1.25714"></path>
              <path d="M2.91818 7.65714H19.9468V16.6794C19.9468 18.5764 18.4089 20.1143 16.5118 20.1143H6.35311C4.45605 20.1143 2.91818 18.5764 2.91818 16.6794V7.65714Z" stroke="#4A4A4A" stroke-width="1.25714"></path>
            </svg>
          </span>

          <div class="loading-overlay__spinner tw-top-0 tw-left-[1rem] !tw-w-[24px] !tw-h-[24px] hidden">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>

        <input type="hidden" name="product-id" value="${productId}">
        <input type="hidden" name="section-id" value="undefined">
      
      </form>
    </product-form>`;
}

function createSoldOut(productId) {
  return `
    <product-form class="tw-w-full tw-flex tw-justify-end">
      <form method="post" action="/cart/add" 
        id="product-form--undefined--${productId}" 
        accept-charset="UTF-8" 
        class="form" 
        enctype="multipart/form-data" 
        novalidate 
        data-type="add-to-cart-form">

        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="id" value="0">

        <div class="sold-out-text tw-text-[1.2rem] md:tw-text-[1.4rem] tw-font-medium tw-text-[#4a4a4a] tw-opacity-50">
          Sold Out
        </div>

        <input type="hidden" name="product-id" value="${productId}">
        <input type="hidden" name="section-id" value="undefined">

      </form>
    </product-form>`;
}



// ---- Update price, discount, image, title ----
function updateProductCardUI(productCard, variantData) {
  const priceEl = productCard.querySelector('.selling-price');
  const compareEl = productCard.querySelector('.compare-at-price');
  const discountEl = productCard.querySelector('.discount-percentage');
  const titleEl = productCard.querySelector('.product-card__title span');
  const img = productCard.querySelector('.product-card-image');

  const price = variantData.price / 100;
  const compareAt = variantData.compare_at_price ? variantData.compare_at_price / 100 : null;
  const discount = compareAt ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

  if (priceEl) priceEl.textContent = `₹ ${price}`;
  if (compareEl) {
    if (compareAt) {
      compareEl.textContent = `₹ ${compareAt}`;
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }
  if (discountEl) {
    if (discount > 0) {
      discountEl.textContent = `${discount}% OFF`;
      discountEl.style.display = '';
    } else {
      discountEl.style.display = 'none';
    }
  }
  if (titleEl) titleEl.textContent = variantData.title;
  if(img){
    const newImageUrl = (variantData.images?.length > 0 ? "https:" + variantData.images[0] : DEFAULT_IMAGE);
    img.src = newImageUrl;
    img.alt = variantData.title;
  }
  if (variantData.handle) {
    productCard.setAttribute('data-product-variant-handle', variantData.handle);
  }

  if (variantData.handle) {
    const anchors = productCard.querySelectorAll('a');
    anchors.forEach(anchor => {
      anchor.href = `/products/${variantData.handle}`;
    });
  }
}

})

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".top-filter-container");

  const url = new URL(window.location.href);
  let categories = url.searchParams.get("f.Category");

  let initialList = categories ? categories.split(",") : [];

  if (initialList.length > 0) {
    elements.forEach(el => {
      const label = el.getAttribute("data-label");
      const labelLower = label.toLowerCase().trim();
      if (initialList.includes(labelLower)) {
        el.classList.add("active");
      }
    });
  }

  elements.forEach(el => {
    el.addEventListener("click", () => {
      const label = el.getAttribute("data-label").toLowerCase().trim();
      let categoryList = url.searchParams.get("f.Category");
      let list = categoryList ? categoryList.split(",") : [];

      const isActive = el.classList.contains("active");

      // Toggle active class
      if (!isActive) {
        el.classList.add("active");
        if (!list.includes(label)) list.push(label);
      } else {
        el.classList.remove("active");
        list = list.filter(item => item !== label);
      }

      // Update URL
      if (list.length > 0) {
        url.searchParams.set("f.Category", list.join(","));
      } else {
        url.searchParams.delete("f.Category");
      }

      let newUrl = url.toString()
        .replace(/%20/g, "+")
        .replace(/%2C/g, ",");

      history.pushState(newUrl, "filter", newUrl);
      window.applyTopFilter(newUrl);
    });
  });

});
